export default "__VITE_ASSET__uEa98kEH__"